<template>
  <div class="fix-popup-wrap">
    <div class="fix-popup">
      <template v-if="opened">
        <h4>{{ error.field }}</h4>
        <div>{{ participant.id }}</div>
        <div>{{ error.error }}</div>

        <roe-error-message
          v-if="error.attribute === 'state_residence_code'"
          :field="$v.participant.state_residence_code"
        >
          <v-select
            v-model="participant.state_residence_code"
            :options="states"
          ></v-select>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'birth_date'"
          :field="$v.participant.birth_date"
        >
          <datepicker
            v-model="participant.birth_date"
            name="birth_date"
            required
          ></datepicker>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'hire_date'"
          :field="$v.participant.hire_date"
        >
          <datepicker
            v-model="participant.hire_date"
            name="hire_date"
            required
          ></datepicker>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'termination_date'"
          :field="$v.participant.termination_date"
        >
          <datepicker
            v-model="participant.termination_date"
            clear-button
            name="termination_date"
          ></datepicker>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'estimated_annual_wages'"
          :field="$v.participant.estimated_annual_wages"
        >
          <input
            type="number"
            v-model="participant.estimated_annual_wages"
            name="estimated_annual_wages"
            required
          />
          <label class="input-label-inside">$</label>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'gender'"
          :field="$v.participant.gender"
        >
          <v-select
            v-model="participant.gender"
            :options="['m', 'f']"
          ></v-select>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'marital_status'"
          :field="$v.participant.marital_status"
        >
          <v-select
            v-model="participant.marital_status"
            :options="['single', 'married']"
          ></v-select>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'hours_per_week'"
          :field="$v.participant.hours_per_week"
        >
          <input
            type="number"
            v-model="participant.hours_per_week"
            name="hours_per_week"
          />
          <label class="input-label-inside">hours</label>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'drd'"
          :field="$v.participant.drd"
        >
          <datepicker
            v-model="participant.drd"
            clear-button
            name="drd"
          ></datepicker>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'drd_income'"
          :field="$v.participant.drd_income"
        >
          <input
            type="number"
            v-model="participant.drd_income"
            name="drd_income"
          />
          <label class="input-label-inside">$</label>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'drd_state'"
          :field="$v.participant.drd_state"
        >
          <v-select
            v-model="participant.drd_state"
            :options="states"
          ></v-select>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'pension'"
          :field="$v.participant.pension"
        >
          <input type="number" v-model="participant.pension" name="pension" />
          <label class="input-label-inside">$</label>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'pre_tax_deferral_ytd_dollars'"
          :field="$v.participant.pre_tax_deferral_ytd_dollars"
        >
          <input
            type="number"
            v-model="participant.pre_tax_deferral_ytd_dollars"
            name="pre_tax_deferral_ytd_dollars"
            required
          />
          <label class="input-label-inside">$</label>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'pre_tax_deferral_percent'"
          :field="$v.participant.pre_tax_deferral_percent"
        >
          <roe-percent-input
            v-model="participant.pre_tax_deferral_percent"
          ></roe-percent-input>
          <label class="input-label-inside">%</label>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'pre_tax_deferral_dollars'"
          :field="$v.participant.pre_tax_deferral_dollars"
        >
          <input
            type="number"
            v-model="participant.pre_tax_deferral_dollars"
            name="pre_tax_deferral_dollars"
            required
          />
          <label class="input-label-inside">$</label>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'pre_tax_deferral_dollars_frequency'"
          :field="$v.participant.pre_tax_deferral_dollars_frequency"
        >
          <v-select
            v-model.number="participant.pre_tax_deferral_dollars_frequency"
            name="pre_tax_deferral_dollars_frequency"
            :options="[12, 24, 26, 52]"
          ></v-select>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'pre_tax_deferral_ytd_catchup_dollars'"
          :field="$v.participant.pre_tax_deferral_ytd_catchup_dollars"
        >
          <input
            type="number"
            v-model="participant.pre_tax_deferral_ytd_catchup_dollars"
            name="pre_tax_deferral_ytd_catchup_dollars"
            required
          />
          <label class="input-label-inside">$</label>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'pre_tax_deferral_percent_catchup'"
          :field="$v.participant.pre_tax_deferral_percent_catchup"
        >
          <roe-percent-input
            v-model="participant.pre_tax_deferral_percent_catchup"
          ></roe-percent-input>
          <label class="input-label-inside">%</label>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'pre_tax_deferral_dollars_catchup'"
          :field="$v.participant.pre_tax_deferral_dollars_catchup"
        >
          <input
            type="number"
            v-model="participant.pre_tax_deferral_dollars_catchup"
            name="pre_tax_deferral_dollars_catchup"
            required
          />
          <label class="input-label-inside">$</label>
        </roe-error-message>

        <roe-error-message
          v-if="
            error.attribute === 'pre_tax_deferral_dollars_catchup_frequency'
          "
          :field="$v.participant.pre_tax_deferral_dollars_catchup_frequency"
        >
          <v-select
            v-model.number="
              participant.pre_tax_deferral_dollars_catchup_frequency
            "
            name="pre_tax_deferral_dollars_catchup_frequency"
            :options="[12, 24, 26, 52]"
          ></v-select>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'opt_out_pre_tax'"
          :field="$v.participant.opt_out_pre_tax"
        >
          <v-select
            v-model="participant.opt_out_pre_tax"
            name="opt_out_pre_tax"
            :options="['yes', 'no']"
            required
          >
          </v-select>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'effective_date_pre_tax'"
          :field="$v.participant.effective_date_pre_tax"
        >
          <datepicker
            v-model="participant.effective_date_pre_tax"
            clear-button
            name="effective_date_pre_tax"
          ></datepicker>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'frequency_type_pre_tax'"
          :field="$v.participant.frequency_type_pre_tax"
        >
          <v-select
            v-model="participant.frequency_type_pre_tax"
            name="frequency_type_pre_tax"
            :options="['A', 'P', 'H', 'E', 'S']"
            required
          >
          </v-select>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'annual_pre_tax_percent'"
          :field="$v.participant.annual_pre_tax_percent"
        >
          <roe-percent-input
            v-model="participant.annual_pre_tax_percent"
          ></roe-percent-input>
          <label class="input-label-inside">%</label>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'maximum_pre_tax_percent'"
          :field="$v.participant.maximum_pre_tax_percent"
        >
          <roe-percent-input
            v-model="participant.maximum_pre_tax_percent"
          ></roe-percent-input>
          <label class="input-label-inside">%</label>
        </roe-error-message>
        <roe-error-message
          v-if="error.attribute === 'annual_date_pre_tax'"
          :field="$v.participant.annual_date_pre_tax"
        >
          <input
            type="number"
            v-model="participant.annual_date_pre_tax"
            name="annual_date_pre_tax"
            required
          />
        </roe-error-message>
        <roe-error-message
          v-if="error.attribute === 'frequency1_pre_tax'"
          :field="$v.participant.frequency1_pre_tax"
        >
          <input
            type="text"
            v-model="participant.frequency1_pre_tax"
            name="frequency1_pre_tax"
            required
          />
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'frequency2_pre_tax'"
          :field="$v.participant.frequency2_pre_tax"
        >
          <input
            type="text"
            v-model="participant.frequency2_pre_tax"
            name="frequency2_pre_tax"
            required
          />
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'roth_deferral_ytd_dollars'"
          :field="$v.participant.roth_deferral_ytd_dollars"
        >
          <input
            type="number"
            v-model="participant.roth_deferral_ytd_dollars"
            name="roth_deferral_ytd_dollars"
            required
          />
          <label class="input-label-inside">$</label>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'roth_deferral_percent'"
          :field="$v.participant.roth_deferral_percent"
        >
          <roe-percent-input
            v-model="participant.roth_deferral_percent"
          ></roe-percent-input>
          <label class="input-label-inside">%</label>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'roth_deferral_dollars'"
          :field="$v.participant.roth_deferral_dollars"
        >
          <input
            type="number"
            v-model="participant.roth_deferral_dollars"
            name="roth_deferral_dollars"
            required
          />
          <label class="input-label-inside">$</label>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'roth_deferral_dollars_frequency'"
          :field="$v.participant.roth_deferral_dollars_frequency"
        >
          <v-select
            v-model.number="participant.roth_deferral_dollars_frequency"
            name="roth_deferral_dollars_frequency"
            :options="[12, 24, 26, 52]"
          ></v-select>
        </roe-error-message>
        <roe-error-message
          v-if="error.attribute === 'roth_deferral_ytd_catchup_dollars'"
          :field="$v.participant.roth_deferral_ytd_catchup_dollars"
        >
          <input
            type="number"
            v-model="participant.roth_deferral_ytd_catchup_dollars"
            name="roth_deferral_ytd_catchup_dollars"
            required
          />
          <label class="input-label-inside">$</label>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'roth_deferral_percent_catchup'"
          :field="$v.participant.roth_deferral_percent_catchup"
        >
          <roe-percent-input
            v-model="participant.roth_deferral_percent_catchup"
          ></roe-percent-input>
          <label class="input-label-inside">%</label>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'roth_deferral_dollars_catchup'"
          :field="$v.participant.roth_deferral_dollars_catchup"
        >
          <input
            type="number"
            v-model="participant.roth_deferral_dollars_catchup"
            name="roth_deferral_dollars_catchup"
            required
          />
          <label class="input-label-inside">$</label>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'roth_deferral_dollars_catchup_frequency'"
          :field="$v.participant.roth_deferral_dollars_catchup_frequency"
        >
          <v-select
            v-model.number="participant.roth_deferral_dollars_catchup_frequency"
            name="roth_deferral_dollars_catchup_frequency"
            :options="[12, 24, 26, 52]"
          ></v-select>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'opt_out_roth'"
          :field="$v.participant.opt_out_roth"
        >
          <v-select
            v-model="participant.opt_out_roth"
            name="opt_out_roth"
            :options="['yes', 'no']"
            required
          >
          </v-select>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'plan_id'"
          :field="$v.participant.plan_id"
        >
          <input v-model="participant.plan_id" name="plan_id" required />
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'pre_tax_catchup_spillover'"
          :field="$v.participant.pre_tax_catchup_spillover"
        >
          <v-select
            v-model="participant.pre_tax_catchup_spillover"
            name="pre_tax_catchup_spillover"
            :options="['0', '1']"
            required
          >
          </v-select>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'roth_catchup_spillover'"
          :field="$v.participant.roth_catchup_spillover"
        >
          <v-select
            v-model="participant.roth_catchup_spillover"
            name="roth_catchup_spillover"
            :options="['0', '1']"
            required
          >
          </v-select>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'employee_type_code'"
          :field="$v.participant.employee_type_code"
        >
          <v-select
            v-model="participant.employee_type_code"
            name="employee_type_code"
            :options="['F', 'P', 'S', 'U', 'L', 'I']"
            required
          >
          </v-select>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'increase_opt_out_date_pre_tax'"
          :field="$v.participant.increase_opt_out_date_pre_tax"
        >
          <datepicker
            v-model="participant.increase_opt_out_date_pre_tax"
            clear-button
            name="increase_opt_out_date_pre_tax"
          ></datepicker>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'increase_opt_out_date_roth'"
          :field="$v.participant.increase_opt_out_date_roth"
        >
          <datepicker
            v-model="participant.increase_opt_out_date_roth"
            clear-button
            name="increase_opt_out_date_roth"
          ></datepicker>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'effective_date_roth'"
          :field="$v.participant.effective_date_roth"
        >
          <datepicker
            v-model="participant.effective_date_roth"
            clear-button
            name="effective_date_roth"
          ></datepicker>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'frequency_type_roth'"
          :field="$v.participant.frequency_type_roth"
        >
          <v-select
            v-model="participant.frequency_type_roth"
            name="frequency_type_roth"
            :options="['A', 'P', 'H', 'E', 'S']"
            required
          >
          </v-select>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'annual_roth_percent'"
          :field="$v.participant.annual_roth_percent"
        >
          <roe-percent-input
            v-model="participant.annual_roth_percent"
          ></roe-percent-input>
          <label class="input-label-inside">%</label>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'maximum_roth_percent'"
          :field="$v.participant.maximum_roth_percent"
        >
          <roe-percent-input
            v-model="participant.maximum_roth_percent"
          ></roe-percent-input>
          <label class="input-label-inside">%</label>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'annual_date_roth'"
          :field="$v.participant.annual_date_roth"
        >
          <input
            type="number"
            v-model="participant.annual_date_roth"
            name="annual_date_roth"
            required
          />
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'frequency1_roth'"
          :field="$v.participant.frequency1_roth"
        >
          <input
            type="number"
            v-model="participant.frequency1_roth"
            name="frequency1_roth"
            required
          />
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'frequency2_roth'"
          :field="$v.participant.frequency2_roth"
        >
          <input
            type="number"
            v-model="participant.frequency2_roth"
            name="frequency2_roth"
            required
          />
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'post_tax_deferral_ytd_dollars'"
          :field="$v.participant.post_tax_deferral_ytd_dollars"
        >
          <input
            type="number"
            v-model="participant.post_tax_deferral_ytd_dollars"
            name="post_tax_deferral_ytd_dollars"
            required
          />
          <label class="input-label-inside">$</label>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'post_tax_deferral_percent'"
          :field="$v.participant.post_tax_deferral_percent"
        >
          <roe-percent-input
            v-model="participant.post_tax_deferral_percent"
          ></roe-percent-input>
          <label class="input-label-inside">%</label>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'post_tax_deferral_dollars'"
          :field="$v.participant.post_tax_deferral_dollars"
        >
          <input
            type="number"
            v-model="participant.post_tax_deferral_dollars"
            name="post_tax_deferral_dollars"
            required
          />
          <label class="input-label-inside">$</label>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'post_tax_deferral_dollars_frequency'"
          :field="$v.participant.post_tax_deferral_dollars_frequency"
        >
          <v-select
            v-model.number="participant.post_tax_deferral_dollars_frequency"
            name="post_tax_deferral_dollars_frequency"
            :options="[12, 24, 26, 52]"
          ></v-select>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'effective_date_post_tax'"
          :field="$v.participant.effective_date_post_tax"
        >
          <datepicker
            v-model="participant.effective_date_post_tax"
            clear-button
            name="effective_date_post_tax"
          ></datepicker>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'frequency_type_post_tax'"
          :field="$v.participant.frequency_type_post_tax"
        >
          <v-select
            v-model="participant.frequency_type_post_tax"
            name="frequency_type_post_tax"
            :options="['A', 'P', 'H', 'E', 'S']"
            required
          >
          </v-select>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'annual_post_tax_percent'"
          :field="$v.participant.annual_post_tax_percent"
        >
          <roe-percent-input
            v-model="participant.annual_post_tax_percent"
          ></roe-percent-input>
          <label class="input-label-inside">%</label>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'maximum_post_tax_percent'"
          :field="$v.participant.maximum_post_tax_percent"
        >
          <roe-percent-input
            v-model="participant.maximum_post_tax_percent"
          ></roe-percent-input>
          <label class="input-label-inside">%</label>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'annual_date_post_tax'"
          :field="$v.participant.annual_date_post_tax"
        >
          <input
            type="number"
            v-model="participant.annual_date_post_tax"
            name="annual_date_post_tax"
            required
          />
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'frequency1_post_tax'"
          :field="$v.participant.frequency1_post_tax"
        >
          <input
            type="number"
            v-model="participant.frequency1_post_tax"
            name="frequency1_post_tax"
            required
          />
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'frequency2_post_tax'"
          :field="$v.participant.frequency2_post_tax"
        >
          <input
            type="number"
            v-model="participant.frequency2_post_tax"
            name="frequency2_post_tax"
            required
          />
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'er_match_ytd_dollars'"
          :field="$v.participant.er_match_ytd_dollars"
        >
          <input
            type="number"
            v-model="participant.er_match_ytd_dollars"
            name="er_match_ytd_dollars"
            required
          />
          <label class="input-label-inside">$</label>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'er_other_ytd_dollars'"
          :field="$v.participant.er_other_ytd_dollars"
        >
          <input
            type="number"
            v-model="participant.er_other_ytd_dollars"
            name="er_other_ytd_dollars"
            required
          />
          <label class="input-label-inside">$</label>
        </roe-error-message>

        <!--TODO: Bug with balance validations-->
        <roe-error-message
          v-if="error.attribute === 'pre_tax_balance'"
          :field="$v.participant.pre_tax_balance"
        >
          <input
            type="number"
            v-model="participant.pre_tax_balance"
            name="pre_tax_balance"
            required
          />
          <label class="input-label-inside">$</label>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'roth_balance'"
          :field="$v.participant.roth_balance"
        >
          <input
            type="number"
            v-model="participant.roth_balance"
            name="roth_balance"
            required
          />
          <label class="input-label-inside">$</label>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'post_tax_balance'"
          :field="$v.participant.post_tax_balance"
        >
          <input
            type="number"
            v-model="participant.post_tax_balance"
            name="post_tax_balance"
            required
          />
          <label class="input-label-inside">$</label>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'post_tax_basic_balance'"
          :field="$v.participant.post_tax_basic_balance"
        >
          <input
            type="number"
            v-model="participant.post_tax_basic_balance"
            name="post_tax_basic_balance"
            required
          />
          <label class="input-label-inside">$</label>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'rollover_balance'"
          :field="$v.participant.rollover_balance"
        >
          <input
            type="number"
            v-model="participant.rollover_balance"
            name="rollover_balance"
            required
          />
          <label class="input-label-inside">$</label>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'er_match_balance'"
          :field="$v.participant.er_match_balance"
        >
          <input
            type="number"
            v-model="participant.er_match_balance"
            name="er_match_balance"
            required
          />
          <label class="input-label-inside">$</label>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'er_other_balance'"
          :field="$v.participant.er_other_balance"
        >
          <input
            type="number"
            v-model="participant.er_other_balance"
            name="er_other_balance"
            required
          />
          <label class="input-label-inside">$</label>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'other_pre_tax_balance'"
          :field="$v.participant.other_pre_tax_balance"
        >
          <input
            type="number"
            v-model="participant.other_pre_tax_balance"
            name="other_pre_tax_balance"
            required
          />
          <label class="input-label-inside">$</label>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'other_roth_balance'"
          :field="$v.participant.other_roth_balance"
        >
          <input
            type="number"
            v-model="participant.other_roth_balance"
            name="other_roth_balance"
            required
          />
          <label class="input-label-inside">$</label>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'other_post_tax_balance'"
          :field="$v.participant.other_post_tax_balance"
        >
          <input
            type="number"
            v-model="participant.other_post_tax_balance"
            name="other_post_tax_balance"
            required
          />
          <label class="input-label-inside">$</label>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'nqdc_deferral_ytd'"
          :field="$v.participant.nqdc_deferral_ytd"
        >
          <input
            type="number"
            v-model="participant.nqdc_deferral_ytd"
            name="nqdc_deferral_ytd"
            required
          />
          <label class="input-label-inside">$</label>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'nqdc_deferral_percent'"
          :field="$v.participant.nqdc_deferral_percent"
        >
          <roe-percent-input
            type="number"
            v-model="participant.nqdc_deferral_percent"
            name="nqdc_deferral_percent"
            required
          ></roe-percent-input>
          <label class="input-label-inside">%</label>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'nqdc_deferral_dollars'"
          :field="$v.participant.nqdc_deferral_dollars"
        >
          <input
            type="number"
            v-model="participant.nqdc_deferral_dollars"
            name="nqdc_deferral_dollars"
            required
          />
          <label class="input-label-inside">$</label>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'nqdc_deferral_dollars_frequency'"
          :field="$v.participant.nqdc_deferral_dollars_frequency"
        >
          <v-select
            v-model.number="participant.nqdc_deferral_dollars_frequency"
            name="nqdc_deferral_dollars_frequency"
            :options="[12, 24, 26, 52]"
          ></v-select>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'nqdc_balance'"
          :field="$v.participant.nqdc_balance"
        >
          <input
            type="number"
            v-model="participant.nqdc_balance"
            name="nqdc_balance"
            required
          />
          <label class="input-label-inside">$</label>
        </roe-error-message>

        <roe-error-message
          v-if="error.attribute === 'sponsor_db_plan_monthly_benefit'"
          :field="$v.participant.sponsor_db_plan_monthly_benefit"
        >
          <input
            type="number"
            v-model="participant.sponsor_db_plan_monthly_benefit"
            name="sponsor_db_plan_monthly_benefit"
            required
          />
          <label class="input-label-inside">$</label>
        </roe-error-message>

        <div class="action-btn-wrap">
          <div class="btn-wrap">
            <button
              class="btn-primary"
              :disabled="$v.participant[error.attribute].$invalid"
              @click="updateParticipant"
            >
              Save
            </button>
          </div>
          <div class="btn-wrap">
            <button class="btn-secondary" @click="$emit('close')">
              Cancel
            </button>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { UPDATE_PARTICIPANT } from "@/store/actions.type";
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
import RoePercentInput from "@/components/_shared/inputs/PercentInput";
import { SHOW_FORM_ERRORS } from "@/store/mutations.type";
import {
  required,
  minValue,
  maxValue,
  minLength,
  maxLength,
  numeric,
  helpers,
  requiredIf
} from "vuelidate/lib/validators";
import Datepicker from "vuejs-datepicker";
import { mapGetters } from "vuex";

function minDate(date) {
  return helpers.withParams({ type: "minDate", min: date }, function(value) {
    return (
      !helpers.req(value) ||
      !helpers.req(date) ||
      new Date(new Date(value).toISOString().substring(0, 10)) >
        new Date(date.toISOString().substring(0, 10))
    );
  });
}
function maxDate(date) {
  return helpers.withParams({ type: "maxDate", max: date }, function(value) {
    return (
      !helpers.req(value) ||
      !date ||
      new Date(new Date(value).toISOString().substring(0, 10)) <=
        new Date(date.toISOString().substring(0, 10))
    );
  });
}

function datePrevYears(years) {
  let currentDate = new Date();
  let date = new Date(
    currentDate.setFullYear(currentDate.getFullYear() - years)
  );
  date.setDate(currentDate.getDate() - 1);
  return new Date(date);
}

function dateNextYears(date, years) {
  if (date === undefined) return;
  date = new Date(date);
  return new Date(date.setFullYear(date.getFullYear() + years));
}

export default {
  name: "RoeFixParticipantForm",
  components: {
    RoePercentInput,
    RoeErrorMessage,
    Datepicker
  },
  props: {
    opened: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      error: null,
      participantError: {},
      participant: {
        id: undefined,
        gender: undefined,
        state_residence_code: undefined,
        birth_date: undefined,
        hire_date: undefined,
        termination_date: undefined,
        estimated_annual_wages: undefined,
        marital_status: undefined,
        drd: undefined,
        drd_income: undefined,
        drd_state: undefined,
        hours_per_week: undefined,
        employee_type_code: undefined,
        pension: undefined,
        pre_tax_deferral_ytd_dollars: undefined,
        pre_tax_deferral_percent: undefined,
        pre_tax_deferral_dollars: undefined,
        pre_tax_deferral_dollars_frequency: undefined,
        pre_tax_deferral_ytd_catchup_dollars: undefined,
        pre_tax_deferral_percent_catchup: undefined,
        pre_tax_deferral_dollars_catchup: undefined,
        pre_tax_deferral_dollars_catchup_frequency: undefined,
        pre_tax_catchup_spillover: undefined,
        opt_out_pre_tax: undefined,
        effective_date_pre_tax: undefined,
        frequency_type_pre_tax: undefined,
        annual_pre_tax_percent: undefined,
        maximum_pre_tax_percent: undefined,
        annual_date_pre_tax: undefined,
        frequency1_pre_tax: undefined,
        frequency2_pre_tax: undefined,
        increase_opt_out_date_pre_tax: undefined,
        roth_deferral_ytd_dollars: undefined,
        roth_deferral_percent: undefined,
        roth_deferral_dollars: undefined,
        roth_deferral_dollars_frequency: undefined,
        roth_deferral_ytd_catchup_dollars: undefined,
        roth_deferral_percent_catchup: undefined,
        roth_deferral_dollars_catchup: undefined,
        roth_deferral_dollars_catchup_frequency: undefined,
        opt_out_roth: undefined,
        effective_date_roth: undefined,
        frequency_type_roth: undefined,
        annual_roth_percent: undefined,
        maximum_roth_percent: undefined,
        annual_date_roth: undefined,
        frequency1_roth: undefined,
        frequency2_roth: undefined,
        roth_catchup_spillover: undefined,
        increase_opt_out_date_roth: undefined,
        post_tax_deferral_ytd_dollars: undefined,
        post_tax_deferral_percent: undefined,
        post_tax_deferral_dollars: undefined,
        post_tax_deferral_dollars_frequency: undefined,
        effective_date_post_tax: undefined,
        frequency_type_post_tax: undefined,
        annual_post_tax_percent: undefined,
        maximum_post_tax_percent: undefined,
        annual_date_post_tax: undefined,
        frequency1_post_tax: undefined,
        frequency2_post_tax: undefined,
        er_match_ytd_dollars: undefined,
        er_other_ytd_dollars: undefined,
        pre_tax_balance: undefined,
        roth_balance: undefined,
        post_tax_balance: undefined,
        post_tax_basic_balance: undefined,
        er_match_balance: undefined,
        er_other_balance: undefined,
        other_pre_tax_balance: undefined,
        other_roth_balance: undefined,
        other_post_tax_balance: undefined,
        nqdc_deferral_ytd: undefined,
        nqdc_deferral_percent: undefined,
        nqdc_deferral_dollars: undefined,
        nqdc_deferral_dollars_frequency: undefined,
        nqdc_balance: undefined,
        sponsor_db_plan_monthly_benefit: undefined
      },
      states: [
        "AK",
        "AL",
        "AR",
        "AZ",
        "CA",
        "CO",
        "CT",
        "DC",
        "DE",
        "FL",
        "GA",
        "HI",
        "IA",
        "ID",
        "IL",
        "IN",
        "KS",
        "KY",
        "LA",
        "MA",
        "MD",
        "ME",
        "MI",
        "MN",
        "MO",
        "MS",
        "MT",
        "NC",
        "ND",
        "NE",
        "NH",
        "NJ",
        "NM",
        "NV",
        "NY",
        "OH",
        "OK",
        "OR",
        "PA",
        "RI",
        "SC",
        "SD",
        "TN",
        "TX",
        "UT",
        "VA",
        "VT",
        "WA",
        "WI",
        "WV",
        "WY"
      ]
    };
  },
  validations() {
    return {
      participant: {
        plan_id: { required },
        gender: { required },
        state_residence_code: { required },
        birth_date: {
          required,
          minDate: minDate(datePrevYears(70)),
          maxDate: maxDate(datePrevYears(16))
        },
        hire_date: {
          required,
          minDate: minDate(dateNextYears(this.participantError.birth_date, 16)),
          maxDate: maxDate(new Date())
        },
        termination_date: {
          minDate: minDate(new Date(this.participantError.hire_date))
        },
        estimated_annual_wages: {
          required,
          minValue: minValue(0),
          currency: true
        },
        hours_per_week: {
          required,
          minValue: minValue(1),
          maxValue: maxValue(45)
        },
        employee_type_code: { required },
        marital_status: { required },
        drd: {
          minDate: minDate(new Date(this.participantError.hire_date))
        },
        drd_income: { required, minValue: minValue(0) },
        drd_state: { required },
        pension: { required, minValue: minValue(0), currency: true },
        pre_tax_deferral_ytd_dollars: {
          required,
          minValue: minValue(0),
          maxValue: maxValue(this.complianceLimits.max_deferral),
          currency: true
        },
        pre_tax_deferral_percent: {
          required,
          minValue: minValue(0),
          maxValue: maxValue(
            this.originalPlan.employee_contrib_pretax_max_contribution_percent
          ),
          percent: true
        },
        pre_tax_deferral_dollars: {
          required,
          minValue: minValue(0),
          maxValue: maxValue(
            (this.originalPlan
              .employee_contrib_pretax_max_contribution_percent *
              this.participantError.estimated_annual_wages) /
              this.participantError.pre_tax_deferral_dollars_frequency
          ),
          currency: true
        },
        pre_tax_deferral_dollars_frequency: { required },
        pre_tax_deferral_ytd_catchup_dollars: {
          required,
          minValue: minValue(0),
          maxValue: maxValue(this.complianceLimits.catch_up),
          currency: true
        },
        pre_tax_deferral_percent_catchup: {
          required,
          minValue: minValue(0),
          maxValue: maxValue(
            this.originalPlan.employee_contrib_pretax_max_contribution_percent
          ),
          percent: true
        },
        pre_tax_deferral_dollars_catchup: {
          required,
          minValue: minValue(0),
          maxValue: maxValue(this.complianceLimits.catch_up),
          currency: true
        },
        pre_tax_deferral_dollars_catchup_frequency: { required },
        opt_out_pre_tax: { required },
        effective_date_pre_tax: { required }, // TODO: Specific MM/DD/YYYY date CANNOT be < EE Eligibility Date
        frequency_type_pre_tax: { required },
        annual_pre_tax_percent: {
          required,
          minValue: minValue(0.01),
          maxValue: maxValue(0.05),
          percent: true
        },
        maximum_pre_tax_percent: {
          required,
          minValue: minValue(0),
          maxValue: maxValue(
            this.originalPlan.employee_contrib_pretax_max_contribution_percent
          ),
          percent: true
        },
        annual_date_pre_tax: {
          required,
          numeric,
          minLength: minLength(4),
          maxLength: maxLength(4)
        },
        frequency1_pre_tax: {
          required,
          numeric,
          minLength: minLength(4),
          maxLength: maxLength(4)
        },
        frequency2_pre_tax: {
          required,
          numeric,
          minLength: minLength(4),
          maxLength: maxLength(4)
        },
        pre_tax_catchup_spillover: { required },
        increase_opt_out_date_pre_tax: {
          required,
          minDate: minDate(new Date(this.participantError.hire_date))
        },
        roth_deferral_ytd_dollars: {
          required,
          minValue: minValue(0),
          maxValue: maxValue(this.complianceLimits.max_deferral),
          currency: true
        },
        roth_deferral_percent: {
          required,
          minValue: minValue(0),
          maxValue: maxValue(
            this.originalPlan.employee_contrib_roth_max_contribution
          ),
          percent: true
        },
        roth_deferral_dollars: {
          required,
          minValue: minValue(0),
          maxValue: maxValue(
            (this.originalPlan.employee_contrib_roth_max_contribution *
              this.participantError.estimated_annual_wages) /
              this.participantError.roth_deferral_dollars_frequency
          ),
          currency: true
        },
        roth_deferral_dollars_frequency: { required },
        roth_deferral_ytd_catchup_dollars: {
          required,
          minValue: minValue(0),
          maxValue: maxValue(this.complianceLimits.catch_up),
          currency: true
        },
        roth_deferral_percent_catchup: {
          required,
          minValue: minValue(0),
          maxValue: maxValue(
            this.originalPlan.employee_contrib_roth_max_contribution
          ),
          percent: true
        },
        roth_deferral_dollars_catchup: {
          required,
          minValue: minValue(0),
          maxValue: maxValue(this.complianceLimits.catch_up),
          currency: true
        },
        roth_deferral_dollars_catchup_frequency: { required },
        opt_out_roth: { required },
        effective_date_roth: { required }, // TODO: Specific MM/DD/YYYY date CANNOT be < EE Eligibility Date
        frequency_type_roth: { required },
        annual_roth_percent: {
          required,
          minValue: minValue(0.01),
          maxValue: maxValue(0.05),
          percent: true
        },
        maximum_roth_percent: {
          required,
          minValue: minValue(0),
          maxValue: maxValue(
            this.originalPlan.employee_contrib_roth_max_contribution
          ),
          percent: true
        },
        annual_date_roth: {
          required,
          numeric,
          minLength: minLength(4),
          maxLength: maxLength(4)
        },
        frequency1_roth: {
          required,
          numeric,
          minLength: minLength(4),
          maxLength: maxLength(4)
        },
        frequency2_roth: {
          required,
          numeric,
          minLength: minLength(4),
          maxLength: maxLength(4)
        },
        roth_catchup_spillover: { required },
        increase_opt_out_date_roth: {
          required,
          minDate: minDate(new Date(this.participantError.hire_date))
        },
        post_tax_deferral_ytd_dollars: {
          required,
          minValue: minValue(0),
          maxValue: maxValue(this.complianceLimits.max_contribution_dc_plan),
          currency: true
        },
        post_tax_deferral_percent: {
          required,
          minValue: minValue(0),
          maxValue: maxValue(
            this.originalPlan.employee_contrib_aftertax_max_contribution
          ),
          percent: true
        },
        post_tax_deferral_dollars: {
          required,
          minValue: minValue(0),
          maxValue: maxValue(
            (this.originalPlan.employee_contrib_aftertax_max_contribution *
              this.participantError.estimated_annual_wages) /
              this.participantError.post_tax_deferral_dollars_frequency
          ),
          currency: true
        },
        post_tax_deferral_dollars_frequency: { required },
        effective_date_post_tax: { required }, // TODO: Specific MM/DD/YYYY date CANNOT be < EE Eligibility Date
        frequency_type_post_tax: { required },
        annual_post_tax_percent: {
          required,
          minValue: minValue(0.01),
          maxValue: maxValue(0.05),
          percent: true
        },
        maximum_post_tax_percent: {
          required,
          minValue: minValue(0),
          maxValue: maxValue(
            this.originalPlan.employee_contrib_aftertax_max_contribution
          ),
          percent: true
        },
        annual_date_post_tax: {
          required,
          numeric,
          minLength: minLength(4),
          maxLength: maxLength(4)
        },
        frequency1_post_tax: {
          required,
          numeric,
          minLength: minLength(4),
          maxLength: maxLength(4)
        },
        frequency2_post_tax: {
          required,
          numeric,
          minLength: minLength(4),
          maxLength: maxLength(4)
        },
        er_match_ytd_dollars: {
          required,
          minValue: minValue(0),
          maxValue: maxValue(this.complianceLimits.max_deferral),
          currency: true
        },
        er_other_ytd_dollars: {
          required,
          minValue: minValue(0),
          maxValue: maxValue(this.complianceLimits.max_deferral),
          currency: true
        },
        pre_tax_balance: { required, minValue: minValue(0), currency: true },
        roth_balance: { required, minValue: minValue(0), currency: true },
        post_tax_balance: { required, minValue: minValue(0), currency: true },
        post_tax_basic_balance: {
          required,
          minValue: minValue(0),
          currency: true
        },
        rollover_balance: { required, minValue: minValue(0), currency: true },
        er_match_balance: { required, minValue: minValue(0), currency: true },
        er_other_balance: { required, minValue: minValue(0), currency: true },
        other_pre_tax_balance: { required, minValue: minValue(0) },
        other_roth_balance: { required, minValue: minValue(0) },
        other_post_tax_balance: { required, minValue: minValue(0) },
        nqdc_deferral_ytd: { required, minValue: minValue(0), currency: true },
        nqdc_deferral_percent: {
          required,
          minValue: minValue(0),
          maxValue: maxValue(1.0),
          percent: true
        },
        nqdc_deferral_dollars: {
          required,
          minValue: minValue(0),
          currency: true
        },
        nqdc_deferral_dollars_frequency: { required },
        nqdc_balance: { required, minValue: minValue(0), currency: true },
        sponsor_db_plan_monthly_benefit: {
          required,
          minValue: minValue(0),
          currency: true
        }
      }
    };
  },
  computed: {
    ...mapGetters(["complianceLimits", "originalPlan"])
  },
  methods: {
    updateParticipant() {
      this.$store.dispatch(UPDATE_PARTICIPANT, {
        reportId: this.$router.currentRoute.params.id,
        params: this.participant
      });
      this.$emit("close");
    },
    initForm(participantError, error) {
      for (let prop in this.participant) {
        if (this.participant.hasOwnProperty(prop))
          this.participant[prop] = undefined;
      }
      this.participantError = participantError;
      this.participant.id = participantError.id;
      if (error.value) this.participant[error.attribute] = error.value;
      this.$store.commit(SHOW_FORM_ERRORS);
      this.error = error;
      this.$emit("open");
    }
  }
};
</script>
